<template>
  <div class="body-2-bold mb-24 flex items-center">
    <div
      class="border-static-default-low rounded-sm relative flex h-40 w-40 items-center justify-center border"
    >
      <RevIllustration
        alt=""
        class="h-32 w-32"
        :height="32"
        :src="item.image"
        :width="32"
      />

      <RevBadge
        v-if="item.quantity && item.quantity > 1"
        class="absolute right-0 top-0 -translate-y-1/2 translate-x-1/2"
        :count="item.quantity"
      />
    </div>
    <div class="text-static-default-hi ml-24">{{ item.title }}</div>
  </div>
</template>

<script setup lang="ts">
import type { CartItem } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'
import { RevBadge } from '@ds/components/Badge'
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{ item: CartItem }>()
</script>
